export default {
  bucketParameter: {
    region: 'oss-cn-hangzhou',
    accessKeyId: 'LTAI4Fvyy3fjZB1Ae5fpzyQP',
    accessKeySecret: '0c7mvxkJrFJzIMQO2MaeChCzStsGf0',
    bucket: 'aixuejie-test',
    secure: true
  },
  resourcePrefix: {
    url: 'http://img.aixuejie.ajeelee.com'
  },
  refresh:{
    isRefresh:false,
    lastConfig:undefined
  }
}



// WEBPACK FOOTER //
// ./src/store/common/state.js